import React, { FC } from 'react';
import { useUser } from '../../../hooks/useUser';
import { HeaderLoggedIn } from '../HeaderLoggedIn/HeaderLoggedIn';
import { SignInButton } from '../SignInButton/SignInButton';

export const HeaderAccountInfo: FC = () => {
  const user = useUser();
  return user.loggedIn ? <HeaderLoggedIn /> : <SignInButton />;
};
